import { ISegmentedControl } from "types/gaiaComponents/segmentedControl";

export const SegmentedControl = ({ options, className, ariaLabel, role }: ISegmentedControl) => {
    return (
        <div className={"ga-segmented-control" + (className ? " " + className : "")}
             aria-label={ariaLabel}
             role={role}>
            {options.map((option, index) => (
                <button type="button"
                        key={option.key ?? index}
                        className={"ga-segmented-control__button" + (option.isSelected ? " ga-segmented-control__button--selected" : "")}
                        onClick={option.onClick}
                        aria-label={option.ariaLabel}
                        aria-pressed={option.isSelected}
                        data-cy={option.dataCy}>
                    {option.label}
                </button>
            ))}
        </div>
    );
};
